import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { isOnboarding } from "./config";

const OnBoardingRoute = ({
  component: Component,
  restricted,
  auth,
  ...rest
}) => {
  console.log(isOnboarding());
  if (localStorage.getItem("accessToken")) {
    if (isOnboarding() === true) return <Navigate to="/current-orders" />;
    else return <Outlet />;
  } else {
    return <Navigate to="/login" />;
  }
};

export default OnBoardingRoute;
